import { NavigateFunction, Location } from 'react-router-dom';
import { analyticsTrack } from '../helpers/AnalyticsUtility';
import {
  ProductToursBuildATemplateIcon,
  ProductToursDownloadTheMobileAppIcon,
  ProductToursFillOutAFormIcon,
  ProductToursLearnAboutTemplatesIcon,
  ProductToursShareAPublicFormIcon,
  ProvideFeedbackAccountManagementIcon,
  ProvideFeedbackFormsIcon,
  ProvideFeedbackMobileAppIcon,
  ProvideFeedbackNotSureIcon,
  ProvideFeedbackReportsIcon,
  ProvideFeedbackWorkflowsIcon,
  VideosFormIcon,
  VideosGettingStartedIcon,
  VideosProTipsIcon,
  VideosTemplatesIcon,
  VideosWebinarIcon
} from './Icons';
import { PageItem, ResourceCenterPage } from './successlauncher-types';

export function getPagesItems(location: Location, navigate: NavigateFunction): PageItem[] {
  return [
    {
      page: 'Provide Feedback',
      title: 'Forms, Templates & Public Forms',
      description: 'Building, editing, sharing, and storing forms and templates',
      icon: ProvideFeedbackFormsIcon,
      action: (setSelectedPage) => {
        analyticsTrack('Success Launcher Feedback Category Clicked', {
          category: 'Forms, Templates & Public Forms'
        });
        setSelectedPage({ page: 'Feedback Form', feedbackType: 'FormsTemplates' });
        return false;
      }
    },
    {
      page: 'Provide Feedback',
      title: 'Account Management',
      description: 'Managing Users & Groups, permissions, and account-wide settings',
      icon: ProvideFeedbackAccountManagementIcon,
      action: (setSelectedPage) => {
        analyticsTrack('Success Launcher Feedback Category Clicked', {
          category: 'Account Management'
        });
        setSelectedPage({ page: 'Feedback Form', feedbackType: 'Account' });
        return false;
      }
    },
    {
      page: 'Provide Feedback',
      title: 'Workflows, Integrations and Automations',
      description: 'Building, editing, and monitoring workflows and automated events',
      icon: ProvideFeedbackWorkflowsIcon,
      action: (setSelectedPage) => {
        analyticsTrack('Success Launcher Feedback Category Clicked', {
          category: 'Workflows, Integrations and Automations'
        });
        setSelectedPage({ page: 'Feedback Form', feedbackType: 'Workflows' });
        return false;
      }
    },
    {
      page: 'Provide Feedback',
      title: 'Reports',
      description: 'Building and exporting customized data reports',
      icon: ProvideFeedbackReportsIcon,
      action: (setSelectedPage) => {
        analyticsTrack('Success Launcher Feedback Category Clicked', {
          category: 'Reports'
        });
        setSelectedPage({ page: 'Feedback Form', feedbackType: 'Reports' });
        return false;
      }
    },
    {
      page: 'Provide Feedback',
      title: 'Mobile App',
      description: 'Mobile-specific form editing, data syncing, offline use, and performance',
      icon: ProvideFeedbackMobileAppIcon,
      action: (setSelectedPage) => {
        analyticsTrack('Success Launcher Feedback Category Clicked', {
          category: 'Mobile App'
        });
        setSelectedPage({ page: 'Feedback Form', feedbackType: 'MobleApps' });
        return false;
      }
    },
    {
      page: 'Provide Feedback',
      title: 'Not Sure',
      description: 'We will sort the feedback for you',
      icon: ProvideFeedbackNotSureIcon,
      action: (setSelectedPage) => {
        analyticsTrack('Success Launcher Feedback Category Clicked', {
          category: 'Not Sure'
        });
        setSelectedPage({ page: 'Feedback Form', feedbackType: 'NotSure' });
        return false;
      }
    },
    {
      page: 'Product Tours',
      title: 'Learn About Templates',
      description: 'Templates are the master version of the form',
      icon: ProductToursLearnAboutTemplatesIcon,
      action: () => {
        analyticsTrack('Success Launcher Product Tour Clicked', {
          tour: 'Learn About Templates'
        });
        if (location.pathname !== '/templates') {
          navigate('/templates');
        }
        window.Appcues.show('2be4e7d6-0e3d-45b8-9279-1cd888a53c80');
        return true;
      }
    },
    {
      page: 'Product Tours',
      title: 'Build a Template',
      description: 'Get started with our Template Editor ',
      icon: ProductToursBuildATemplateIcon,
      action: () => {
        analyticsTrack('Success Launcher Product Tour Clicked', {
          tour: 'Build a Template'
        });
        if (location.pathname !== '/templates/new/selectview') {
          navigate('/templates/new/selectview');
        }
        window.Appcues.show('73d00575-9043-4a7b-a063-f628dec44d4c');
        return true;
      }
    },
    {
      page: 'Product Tours',
      title: 'Fill Out a Form',
      description: 'Learn how to complete a form online',
      icon: ProductToursFillOutAFormIcon,
      action: () => {
        analyticsTrack('Success Launcher Product Tour Clicked', {
          tour: 'Fill Out a Form'
        });
        if (location.pathname !== '/forms') {
          navigate('/forms');
        }
        window.Appcues.show('4e566608-dbaf-4589-ac3f-9871b0559601');
        return true;
      }
    },
    {
      page: 'Product Tours',
      title: 'Share a Public Form',
      description: 'Collect forms from anyone',
      icon: ProductToursShareAPublicFormIcon,
      action: () => {
        analyticsTrack('Success Launcher Product Tour Clicked', {
          tour: 'Share a Public Form'
        });
        if (location.pathname !== '/publicforms') {
          navigate('/publicforms');
        }
        window.Appcues.show('8516205b-c1d4-4967-9ee4-d202b0ea2210');
        return true;
      }
    },
    {
      page: 'Product Tours',
      title: 'Download the Mobile App',
      description: 'Fill out forms on mobile devices',
      icon: ProductToursDownloadTheMobileAppIcon,
      action: () => {
        analyticsTrack('Success Launcher Product Tour Clicked', {
          tour: 'Download the Mobile App'
        });
        window.Appcues.show('a4e4f9fe-824d-4c22-80c8-43cd36e564ec');
        return true;
      }
    },
    {
      page: 'Videos',
      title: 'Getting Started',
      description: 'Follow these simple steps to start using GoFormz',
      icon: VideosGettingStartedIcon,
      action: (setSelectedPage) => {
        analyticsTrack('Success Launcher Video Category Clicked', {
          category: 'Getting Started'
        });
        setSelectedPage({ page: 'Video Page', videoCategory: 'Getting_Started' });
        return false;
      }
    },
    {
      page: 'Videos',
      title: 'Templates',
      description: 'Learn to build and customize your templates',
      icon: VideosTemplatesIcon,
      action: (setSelectedPage) => {
        analyticsTrack('Success Launcher Video Category Clicked', {
          category: 'Templates'
        });
        setSelectedPage({ page: 'Video Page', videoCategory: 'Templates' });
        return false;
      }
    },
    {
      page: 'Videos',
      title: 'Forms',
      description: 'Learn how to fill out forms on mobile devices and online',
      icon: VideosFormIcon,
      action: (setSelectedPage) => {
        analyticsTrack('Success Launcher Video Category Clicked', {
          category: 'Forms'
        });
        setSelectedPage({ page: 'Video Page', videoCategory: 'Forms' });
        return false;
      }
    },
    {
      page: 'Videos',
      title: 'ProTips',
      description: 'Explore best practices and helpful tips',
      icon: VideosProTipsIcon,
      action: (setSelectedPage) => {
        analyticsTrack('Success Launcher Video Category Clicked', {
          category: 'ProTips'
        });
        setSelectedPage({ page: 'Video Page', videoCategory: 'ProTips' });
        return false;
      }
    },
    {
      page: 'Videos',
      title: 'Webinar',
      description: 'Learn about a variety of topics from our team',
      icon: VideosWebinarIcon,
      action: (setSelectedPage) => {
        analyticsTrack('Success Launcher Video Category Clicked', {
          category: 'Webinar'
        });
        setSelectedPage({ page: 'Video Page', videoCategory: 'Webinar' });
        return false;
      }
    }
  ];
}

export function getDescriptionForPage(page: ResourceCenterPage) {
  switch (page) {
    case 'Videos':
      return 'Select a specific category below or choose Getting Started if you are new to GoFormz.';

    case 'Product Tours':
      return 'Select a topic to begin a guided product tour.';

    case 'Provide Feedback':
      return 'We always welcome feedback, please select a category below.';
  }
  return null;
}
